import React from "react";
import DonutChart from "./DonutChart";
import { formatCount } from "../../../utils/numberFormat";

const StatusSection = ({ currentData }) => {

  return (
    <div className="lg:col-span-4">
      <div className="text-center mb-3">
        <h3 className="text-xl my-2 p-0 text-[#3A3A3A] font-bold uppercase text-balance">
          Status
        </h3>
        <div className="mt-3">
          <DonutChart
            data={[
              {
                name: "Completed",
                value: currentData?.statusData?.completed || 0,
              },
              {
                name: "In Progress",
                value: currentData?.statusData?.inProgress || 0,
              },
              {
                name: "Delayed",
                value: currentData?.statusData?.delayed || 0,
              },
              {
                name: "Postponed",
                value: currentData?.statusData?.postponed || 0,
              },
              {
                name: "Cancelled",
                value: currentData?.statusData?.cancelled || 0,
              },
            ]}
            centerValue={
              currentData?.total < 1000
                ? formatCount(currentData?.total)
                : `${(currentData?.total / 1000).toFixed(1)}K`
            }
            centerLabel="Total"
          />
        </div>
      </div>
    </div>
  );
};

export default StatusSection;